import StockList from '../../../components/Purchasing/Stock/StockList'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function Stock (props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/purchasing/stock">Stock</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Stock'}
              subtitle={'Manage Stocks.'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <StockList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Stock.propTypes = {}
Stock.defaultProps = {}

export default Stock
